<template>
  <div class="bonusBanner">
    <img @click="toSign" :src="img" alt="" />
  </div>
</template>

<script>
export default {
  name: "bonusBanner",
  props: {
    campusId: {
      type: String,
      default: '',
    },
    seasonId: {
      type: String,
      default: "s.24.dongji.1.test",
    },
  },
  data() {
    return {
      img: null,
    };
  },
  mounted() {
    this.img = require(`../../../assets/images/winterGame/toBonusPay.png`);
  },
  methods: {
    toSign() {
      this.$router.push({
        path: "/winterGame/bonusPayment",
        query:{
          campusId: this.campusId,
          seasonId: this.seasonId,
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bonusBanner {
  text-align: center;
  margin-bottom: 20px;
  img {
    width: 636px;
    height: 196px;
    position: relative;
    left:-10px;
  }
}
</style>
